<template>
  <div class="modal fade" id="moveSubmissionPageModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">Move Submission</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div id="moveModalTruthText"></div>

          <button
            v-for="page in secondaryPages"
            v-bind:key="page.id"
            type="button"
            class="btn btn-primary rounded-pill btn-block px-2"
            @click="moveSubmission(page.url_prefix)"
          >Move to: {{ page.name }}</button>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary px-3 rounded-pill"
            data-dismiss="modal"
          >Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoveSubmissionPagePopup",

  data() {
    return {
      id: undefined,
      text: ""
    };
  },

  props: {
    submission: {
      id: {
        type: Number,
        required: true
      },
      text: {
        type: String,
        required: true
      }
    },
    secondaryPages: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    show() {
      $("#moveSubmissionPageModal").modal("show");
      this.id = this.submission.id;
      this.text = this.submission.text;
    },
    hide() {
      $("#moveSubmissionPageModal").modal("hide");
    },

    moveSubmission(pageId) {
      let self = this;
      axios
        .post("/api/submissions/" + self.id + "/move", {
          newPage: pageId
        })
        .then(function(response) {
          // this should be on a global event bus, then on the sub items listening to this calls a reload.
          self.$emit("submission-dismissed", self);
          self.hide();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>